import { ChangeDetectionStrategy, Component, ViewChild, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { PermissionFacade } from '../../../../../../../../../../../modules/permission/facades/permission.facade';
import { UserModel } from '../../../../../../../../../../../models/user-permissions.model';
import { ViewColumnComponent } from '../../../../../../../../../../../view-column.component';
import { AppConfig } from '../../../../../../../../../../../visa';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../../../../../../permission-controller/root';
import { UserPermSelectors } from '../../../../../../../../../user-permissions-controller/selectors';
import { app_perm_set_line_RowClass } from 'blg-akaun-ts-lib';
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
  selectedIndex: number;
}

@Component({
  selector: 'app-permission-set-line-details',
  templateUrl: './permission-set-line-details.component.html',
  styleUrls: ['./permission-set-line-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore]
})
export class PermissionSetLineDetailsComponent extends ViewColumnComponent {


  @ViewChild(MatTabGroup, {static: true}) matTab: MatTabGroup;

  protected readonly index = 8;
  private localState: LocalState;

  // info. about previous local states
  prevIndex: number;
  private prevLocalState: any;

  // initialise local states
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(state => state.deactivateReturn);
  readonly selectedIndex$ = this.componentStore.select(state => (state.selectedIndex));

  // api visa
  apiVisa = AppConfig.apiVisa;

  toggleColumn$: Observable<boolean>;

  // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
  private subSink = new SubSink;

  public form: FormGroup;

  currentIndexTab: number;

  formDisabled: boolean = false;

  currentUser: UserModel;
  selectedUser: UserModel;
  readonly selectedPermSetLine$ = this.store.select(UserPermSelectors.selectSelectedPermSetLine);
  selectedPermSet: app_perm_set_line_RowClass[];

  //translation variable
  title: string;
  back_button: string;
  details_text: string;
  permission_code_text: string;
  code_text: string;
  permission_name_text: string;
  name_text: string;
  target_text: string;
  permission_definition_text: string;

  constructor(
    private fb: FormBuilder,
    private store: Store<PermissionStates>,
    private viewColFacade: PermissionFacade,
    private readonly componentStore: ComponentStore<LocalState>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.title = res.view_permission_set_line_details;
        this.back_button = res.back_button;
        this.details_text = res.details;
        this.permission_code_text = res.permission_code;
        this.code_text = res.code;
        this.permission_name_text = res.permission_name;
        this.name_text = res.name;
        this.target_text = res.target;
        this.permission_definition_text = res.permission_definition;
      });
    } else {
      this.title = 'View Permission Set Line Details';
      this.back_button = 'Back';
      this.details_text = 'Details';
      this.permission_code_text = 'Permission Code';
      this.code_text = 'Code';
      this.permission_name_text = 'Permission Name';
      this.name_text = 'Name';
      this.target_text = 'Target';
      this.permission_definition_text = 'Permission Definition';
    }
  }

  /**
   * Lifecycle method: Called when the component is first initialised.
   */
  ngOnInit() {
    this.subSink.sink = this.localState$.subscribe(a => {
      this.localState = a;
      this.componentStore.setState(a);
    });

    this.toggleColumn$ = this.viewColFacade.toggleColumn$;
    this.subSink.sink = this.viewColFacade.prevIndex$.subscribe(resolve => this.prevIndex = resolve);
    this.subSink.sink = this.viewColFacade.prevLocalState$().subscribe(resolve => this.prevLocalState = resolve);

    this.form = this.fb.group({
        permCode: [''],
        permName: [''],
        target: [''],
    })

    this.subSink.sink = this.selectedPermSetLine$
    .subscribe(permSetLine => {
      console.log("permSetLine",permSetLine);
      // set form values
      this.form.patchValue({
        permCode: permSetLine.code,
        permName: permSetLine.name,
        target: permSetLine.target_hdr_table
      });
    })

  }

  /**
   * Return to the previous drawer/view column.
   */
   onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateReturn: false,
      deactivateAdd: false
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  /**
   * Lifecycle method: Called when this component is destroyed.
   */
  ngOnDestroy() {
    if (this.matTab) {
      this.viewColFacade.updateInstance(this.index, {
        ...this.localState,
        selectedIndex: this.matTab.selectedIndex
      });
    }
    this.subSink.unsubscribe();
  }

}
